/**
 * Owner: Masa Bayu
 * File: batch02-fixtures.ts
 * Date:Time: 2026-09-19 20:43
 * Description: Batch 2 certification fixtures — cyrillic · greek (LTR).
 */
import {} from './batch02-codes';
function fixturesFor(familyId, scriptLabel, dirLabel) {
    return Object.freeze([
        Object.freeze({
            id: `fixture:${familyId}/identity`,
            familyId,
            area: 'identity',
            description: `canonical languageId samples for ${familyId}`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/script`,
            familyId,
            area: 'script',
            description: `${scriptLabel} script identity`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/direction-ltr`,
            familyId,
            area: 'direction',
            description: `${dirLabel} default + explicit ltr override`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/content-multilingual`,
            familyId,
            area: 'content',
            description: 'primary + contentLanguages + inline override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/qxw-author-preserve`,
            familyId,
            area: 'qxw',
            description: 'QXW root metadata author → preserve',
        }),
        Object.freeze({
            id: `fixture:${familyId}/qxp-publish-preserve`,
            familyId,
            area: 'qxp',
            description: 'QXP artifact preserve-through-publish',
        }),
        Object.freeze({
            id: `fixture:${familyId}/reader-render-contract`,
            familyId,
            area: 'reader',
            description: 'script typography stacks (render contract)',
        }),
        Object.freeze({
            id: `fixture:${familyId}/search-normalize`,
            familyId,
            area: 'search',
            description: 'NFC normalize + script-aware analyzer prep',
        }),
        Object.freeze({
            id: `fixture:${familyId}/navigation-structure`,
            familyId,
            area: 'navigation',
            description: 'writing mode + heading role metadata',
        }),
        Object.freeze({
            id: `fixture:${familyId}/annotation-anchors`,
            familyId,
            area: 'annotation',
            description: 'original text preserved for anchors',
        }),
        Object.freeze({
            id: `fixture:${familyId}/a11y-lang-semantics`,
            familyId,
            area: 'accessibility',
            description: 'content lang + LTR reading order for AT',
        }),
        Object.freeze({
            id: `fixture:${familyId}/serialize-roundtrip`,
            familyId,
            area: 'serialization',
            description: 'metadata / content round-trip',
        }),
        Object.freeze({
            id: `fixture:${familyId}/regression-suite`,
            familyId,
            area: 'regression',
            description: 'content id stable under override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/provenance-chain`,
            familyId,
            area: 'provenance',
            description: 'source → evidence area trace',
        }),
    ]);
}
export const QX_BATCH_02_CYRILLIC_FIXTURES = fixturesFor('cyrillic', 'Cyrl', 'LTR');
export const QX_BATCH_02_GREEK_FIXTURES = fixturesFor('greek', 'Grek', 'LTR');
export const QX_BATCH_02_FIXTURES = Object.freeze([
    ...QX_BATCH_02_CYRILLIC_FIXTURES,
    ...QX_BATCH_02_GREEK_FIXTURES,
]);
export const QX_BATCH_02_CYRILLIC_SAMPLE_LANGUAGES = Object.freeze([
    'ru',
    'uk',
    'bg',
]);
export const QX_BATCH_02_GREEK_SAMPLE_LANGUAGES = Object.freeze(['el']);
export const QX_BATCH_02_TEXT_SAMPLES = Object.freeze({
    ru: 'Привет, мир — образец сертификации кириллицы.',
    uk: 'Привіт, світ — зразок сертифікації кирилиці.',
    bg: 'Здравей, свят — образец за кирилица.',
    el: 'Γεια σου κόσμε — δείγμα πιστοποίησης ελληνικών.',
    composed: 'cafe\u0301',
});
export function listBatch02FixtureIds(familyId) {
    const list = familyId === 'cyrillic'
        ? QX_BATCH_02_CYRILLIC_FIXTURES
        : familyId === 'greek'
            ? QX_BATCH_02_GREEK_FIXTURES
            : QX_BATCH_02_FIXTURES;
    return Object.freeze(list.map((f) => f.id));
}
export function fixturesForBatch02Family(familyId) {
    return familyId === 'cyrillic'
        ? QX_BATCH_02_CYRILLIC_FIXTURES
        : QX_BATCH_02_GREEK_FIXTURES;
}
//# sourceMappingURL=batch02-fixtures.js.map